/**
 * JURO bento: a soft light that follows the pointer across each cell.
 * Only publishes --juro-mx / --juro-my on the cell being hovered; the glow
 * itself is CSS. Mouse and pen only, nothing on touch, nothing under
 * reduced motion.
 */
(() => {
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!fine.matches || reduced.matches) return;

  document.addEventListener(
    'pointermove',
    (event) => {
      const cell = event.target instanceof Element ? event.target.closest('.juro-bento__cell') : null;
      if (!cell) return;
      const rect = cell.getBoundingClientRect();
      cell.style.setProperty('--juro-mx', `${event.clientX - rect.left}px`);
      cell.style.setProperty('--juro-my', `${event.clientY - rect.top}px`);
    },
    { passive: true }
  );
})();
